import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity } from '@40seas/models';
import { z } from 'zod';
import { DomainAuthStatus } from './domain.auth.status.enum';

export const UserNotificationCustomizationsSchema = z
    .object({
        email: z.string().min(1),
        domain: z.string().min(1),
        status: EnumSchema(DomainAuthStatus),
        dnsRecords: z.any(),
        providerId: z.string().optional(),
        validationResults: z.any().optional(),
    })
    .strict();

export class UserNotificationCustomizations extends FromSchema(UserNotificationCustomizationsSchema) implements BaseEntity {
    id: string;
    email: string;
    domain: string;
    status: DomainAuthStatus;
    dnsRecords: object;
    providerId: string;
    validationResults?: object;

    tenantId: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    timeline?: { [status: string]: { updatedAt: Date } };
    metadata?: { [key: string]: string };
}
